<template>
  <div
    :ref="init"
    v-clickaway="
      () => {
        isVisible = false;
      }
    "
    class="relative"
  >
    <div class="dropdown-toggle">
      <slot
        name="toggle"
        v-bind="{ toggle, isVisible, forceClose }"
      >
        <ui-button
          variant="white"
          v-bind="toggleProps"
          @click="toggle"
        >
          {{
            toggleText
          }}
        </ui-button>
      </slot>
    </div>

    <div
      class="absolute z-100 dropdown-menu"
      :class="{'pointer-events-none': !isVisible}"
    >
      <div
        v-if="!minimalDropdown"
        class="
          z-100
          py-1
          bg-white
          dark:bg-gray-800
          rounded-md
          border
          border-gray-950
          shadow-lg
          transition
          duration-100
          ease-out
          focus:outline-none
          ring-1 ring-black ring-opacity-5
        "
        :class="[
          isVisible
            ? 'transform opacity-100 scale-100'
            : 'transform opacity-0 scale-95 invisible',
          menuClass,
        ]"
        @click="close()"
      >
        <slot v-bind="{ toggle, isVisible, forceClose }" />
      </div>

      <div
        v-if="minimalDropdown"
        class="
          z-100
          transition
          duration-100
          ease-out
        "
        :class="[
          isVisible
            ? 'transform opacity-100 scale-100'
            : 'transform opacity-0 scale-95 invisible',
          menuClass,
        ]"
        @click="close()"
      >
        <slot v-bind="{ toggle, isVisible, forceClose }" />
      </div>
    </div>
  </div>
</template>

<script>
import {
  computePosition,
  shift,
  offset,
  autoPlacement,
} from '@floating-ui/dom';
import UiButton from "@/components/ui/UiButton";
import { defineComponent } from "vue";
export default defineComponent({
  name: "UiDropdown",
  components: { UiButton },
  props: {
    right: {
      type: Boolean,
      default: false,
    },
    top: {
      type: Boolean,
      default: false,
    },
    menuClass: {
      default: "w-48",
      type: String,
    },
    toggleText: {
      default: "Dropdown",
      type: String,
    },
    toggleProps: {
      default() {
        return {};
      },
      type: Object,
    },
    preventClickInsideClose: {
      default: false,
      type: Boolean,
    },
    minimalDropdown: {
      default: false,
      type: Boolean,
    },
  },

  emits: ["visibilityChanged"],

  data() {
    return {
      isVisible: false,
      visibilityChangedSource: null,
    };
  },

  watch: {
    isVisible: {
      handler(value) {
        this.$emit('visibilityChanged', { visibility: value, source: this.visibilityChangedSource });
        this.visibilityChangedSource = null;
      }
    }
  },
  methods: {
    init(el) {
      if (!el) return;
      const button = el.querySelector(".dropdown-toggle");
      const tooltip = el.querySelector(".dropdown-menu");
      computePosition(button, tooltip, {
        placement: `${this.top === false ? 'bottom' : 'top'}-${this.right === false ? 'start' : 'end'}`,
        middleware: [offset(8), autoPlacement({
          alignment: this.right ? 'end' : 'start',
          allowedPlacements: ['top', 'bottom'],
        }), shift({padding: 5})],
      }).then(({x, y}) => {
        Object.assign(tooltip.style, {
          left: `${x}px`,
          top: `${y}px`,
        });
      });
    },
    toggle() {
      this.visibilityChangedSource = 'toggle';
      return (this.isVisible = !this.isVisible);
    },

    close() {
      if (!this.preventClickInsideClose) this.isVisible = false;
    },

    forceClose() {
      this.isVisible = false;
    }
  }
});
</script>

<style scoped>
</style>
